export default __webpack_public_path__ + "static/media/blue_warning.3fc312d2.svg";